import { lazy } from 'react';

export function lazyWithDelay(
  factory: () => Promise<{ default: React.ComponentType<unknown> }>,
  delay = 0
): React.LazyExoticComponent<React.ComponentType<unknown>> {
  return lazy(() => {
    return new Promise(res => {
      setTimeout(() => res(factory()), delay);
    });
  });
}
